import { Injectable } from '@angular/core';

@Injectable()
export class FeedUpdateServiceService {

  constructor() { }

  updatePostArray(postLength, maintenanceLength, eventLength){
    console.log(postLength, maintenanceLength, eventLength);

    return null;
  }

}
